import {FC, useEffect, useState} from 'react'
import { Link } from 'react-router-dom'

import './style.scss'
import {Button, Text, Icon, CustomAlert} from '../../components/UI'
import logoIco from '../../assets/img/logo.svg'
import {alertService} from "../../services/alert.services";

const redirectUrl = (url: string) => {
  window.location.href = url
}

const HeaderCenterItem:FC<{ text: string, url: string, maxWidth?: number }> = ({ text = '', url = '', maxWidth }) => {
  return (
    <a href={url} target="_blank" rel="noreferrer" className="header_centers_item" style={{ maxWidth: (maxWidth ? maxWidth : '') }}>
      <Icon name="location" className="mr-5" />
      <Text component="span" size="12" color="primary" weight="semibold">{text}</Text>
    </a>
  )
}

const HeaderPublic:FC = ()  => {
  const [alerts, setAlerts] = useState<any>({})

  const getAlerts = async () => {
    const alertData = await alertService.getAlertsPublic()
    setAlerts(alertData.data)
  }
  useEffect(() => {
    getAlerts()
  }, [])

  return (
    <header className="header">
      <div className="container">
        <div className="d-flex align-items-center">
          <div className="header_logo">
            <Link to="/">
              <img src={logoIco} alt="Indisa" width="130" height="130" className="header_logo_img" />
            </Link>
          </div>

          <div className="d-none lg:d-block ml-20">
            <ul className="header_centers">
              <li>
                <HeaderCenterItem text="Clínica y Urgencia" url="https://www.indisa.cl/ubicacion-clinica-y-urgencia" maxWidth={90} />
              </li>
              <li>
                <HeaderCenterItem text="Centro Médico Los Españoles" url="https://www.indisa.cl/ubicacion-centro-medico-los-espanoles" maxWidth={120} />
              </li>
              <li>
                <HeaderCenterItem text="Centro Médico Los Conquistadores" url="https://www.indisa.cl/ubicacion-centro-medico-los-conquistadores" maxWidth={150} />
              </li>
            </ul>
          </div>

          <div className="ml-auto">
            <Button color="white" size="md" className="fw-bold lg:d-none" onClick={() => redirectUrl('https://www.indisa.cl')}>VOLVER A INDISA.CL</Button>
            <Button size="md" className="fw-bold d-none lg:d-block" onClick={() => redirectUrl('https://www.indisa.cl')}>VOLVER A INDISA.CL</Button>
          </div>

          {/* <div className="d-block lg:d-none ml-10">
            <button className="menu_btn">
              <img src={menuBtnIcon} alt="" width="35" height="30" />
            </button>
          </div> */}
        </div>
      </div>
      <div className="mb-20 px-10" style={{position: "absolute", zIndex:99, width:'100%'}} >
        { alerts.data && alerts.data.length > 0 && alerts.data.map((it: any, i: number) => {
          const color = it.color
          return (
              <CustomAlert
                  colorBg={`${color.primary_code}`}
                  color={`${color.secundary_code}`}
                  id={'alert_'+`${it.id}`}
              >
                {`${it.text}`}
              </CustomAlert>
          )
        })}
      </div>
    </header>
  )
}

export { HeaderPublic }